import { FC } from 'react';
import { createElement } from 'react-native';

const TimePicker: FC<any> = (props) =>
    createElement('input', { ...props, type: 'time' });

export default TimePicker;
